import Blazy from 'blazy';
let $slider = $('.slick'),
  bLazy = new Blazy();

if($slider.length > 0) {
  let $count = $('.count');

  $slider.on('init', (event, slick) => {
    bLazy.revalidate();
    
    // counter
    $count.text(parseInt(slick.currentSlide + 1) + '/' + slick.slideCount);

    // start playing the first one
    const vid = $(slick.$slides[0]).find('video');
    vid.get(0).play();
  });
  $slider.slick({
    dots: true,
    arrows: true,
    prevArrow: '<a class="slick-arrow slick-prev cursor"></a>',
    nextArrow: '<a class="slick-arrow slick-next cursor"></a>',
    fade: true,
    speed: 800,
    rows: 0,
    autoplay: false,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
  }).on('beforeChange', (event, slick, currentSlide) => {
    const vid = $(slick.$slides[currentSlide]).find('video');
    if(vid) {
      vid.get(0).pause();
      vid.addClass('paused');
    }
  }).on('afterChange', (event, slick, currentSlide) => {
    bLazy.revalidate();
    
    let newHash = parseInt(slick.currentSlide + 1);
    $count.text(newHash + '/' + slick.slideCount);

    const vid = $(slick.$slides[currentSlide]).find('video');
    if(vid) {
      // vid.currentTime = 0;
      vid.get(0).play();
      vid.removeClass('paused');
    }
  });

  $(document).on('click', '.video', function() {
    let video = $(this).get(0);
    $(this).toggleClass('paused');
  
    if (video.paused === false) {
      video.pause();
    } else {
      video.play();
    }
  
    return false;
  });
  
  $('.js-sound-toggle').on('click', function() {
    let $video = $(this).siblings('.video');
    if ($video.prop('muted')) {
      $video.prop('muted', false);
      $(this).addClass('sound-on');
    } else {
      $video.prop('muted', true);
      $(this).removeClass('sound-on');
    }
    console.log($video.prop('muted'))
  });
}